const en = {
  Hi: "Hi",
  Description: "Need help? \n Please check our docs.",
  Documentation: "Documentation",
  EnglishLevel: "English Level",
  FrenchLevel: "French Level",
  EnglishExam: "English Exam",
  FrenchExam: "French Exam",
  ExamType: "Exam Type",
  Score: "Score",
  ReadingScore: "Reading Score",
  WritingScore: "Writing Score",
  ListeningScore: "Listening Score",
  SpeakingScore: "Speaking Score",
  ExamDate: "Exam Date",
  Yes: "Yes",
  Applicant: "Applicant",
  Mother: "Mother",
  Father: "Father",
  Brothers: "Brothers",
  Sisters: "Sisters",
  Children: "Children",
  Education: "Education",
  Relations: "Relations",
  Languages: "Languages",
  Experience: "Experience",
  Activities: "Activities",
  Addresses: "Addresses",
  Travels: "Travels",
  Passports: "Passports",
  OtherInformation: "Other",
  DateofDeath: "Date of Death",
  ApplyForVisaCanadaBefore: "Have you or any of your family members ever applied for a Canadian visa? (Tourist, residential, work, educational, etc.)?",
  VisaCanadaRejectedBefore: "Have you or any family members ever had a visa application for Canada or another country rejected?",
  ReportedExperience: "Have you or any of your family members ever been deported from Canada or any other country?",
  ModifiedDate: "Modified Date",
  SaveChanges: "Save Changes",
  OveralExamScore: "Overal Exam Score",
  ExpireDate: "Expire Date",
  SelectYourLevel: "Select Level",
  DidYouHaveExam: "Did You Have Exam?",
  WitchExam: "Witch Exam?",
  SelectLanguage: "Select Language",
  AsylumApplied: "Have you, or any of your family members, ever applied for asylum in Canada or any other country?",
  ArrestedBefore: "Have you or any of your family members ever committed a crime or been arrested?",
  HealthCareBefore: "In addition to taking medication, do you or any members of your family require help from health care providers while you are in Canada?",
  StayLongerThanVisa: "Do you or a family member have any experience staying in Canada or another country longer than the validity of your visa?",
  TerroristHistory: "Do you or any members of your family have a history of involvement with political groups or terrorist groups, etc",
  SecurityProblems: "Please fully explain if you or any of your family members have any history of malpractice, security problems or previous visa-related action from Canada or any other country.",
  No: "No",
  Expert: "Expert",
  VeryGood: "Very Good",
  Good: "Good",
  Competent: "Competent",
  Modest: "Modest",
  Limited: "Limited",
  None: "None",
  IELTSGeneral: "IELTS General",
  IELTSAcademic: "IELTS Academic",
  CELPIPG: "CELPIP-G",
  TEF: "TEF",
  CELPIP: "CELPIP",
  Gender: "Gender",
  FirstName: "First Name",
  LastName: "Last Name",
  FirstNameNativeLanguage: "First Name (Native Language)",
  LastNameNativeLanguage: "Last Name (Native Language)",
  FirstNameEnglish: "First Name (English)",
  LastNameEnglish: "Last Name (English)",
  DateofBirth: "Birth Date",
  Height: "Height",
  EyeColor: "Eye Color",
  CityofBirth: "City of Birth",
  CountryofBirth: "Country of Birth",
  DeathDate: "Death Date",
  CityofDeath: "City of Death",
  CountryofDeath: "Country of Death",
  PostalCode: "Postal Code",
  JobTitle: "Job Title",
  Company: "Company",
  Email: "Email",
  MaritalStatus: "Marital Status",
  ChildNumber: "Child Number",
  DateofMarriage: "Date of Marriage",
  DateofDivorce: "Date of Divorce",
  Address: "Address",
  NetWorth: "Net Worth",
  EducationLevel: "Education Level",
  EducationMajor: "Education Major",
  MoreAboutEducation: "More About Education",
  WorkExperince: "Work Experince",
  WorkType: "Work Type",
  MoreAboutWork: "More About Work",
  PleaseExplainAboutYourEducationHistory: "Explain educational background in detail",
  PleaseExplainAboutYourJobHistory: "Please Explain About Job History",
  General: "General",
  Profile: "Profile",
  AssessmentForm: "Assessment Form",
  SocialLinks: "Social Links",
  ChangePassword: "Change Password",
  AccountSettings: "Account Settings",
  Account: "Account",
  ClientsEvaluated: "Clients Evaluated",
  ImmigrationCases: "Immigration Cases",
  TotalPosts: "Total Posts",
  About: "About",
  LiveAt: "Live at &nbsp",
  YouAreAssessed: "will evaluate your information",
  AssessingYou: "Assessing You",
  AssessMe: "Assess Me",
  HasAccessDocuments: "has access to your documents",
  DisconnectAccess: "Disconnect Access",
  DocumentAccess: "Access to my data",
  Password: "Password",
  App: "App",
  user: "user",
  List: "List",
  Edit: "Edit",
  Shop: "Shop",
  Blog: "Blog",
  Mail: "Mail",
  Chat: "Chat",
  Cards: "Cards",
  Posts: "Posts",
  Create: "Create",
  Banking: "Banking",
  Booking: "Booking",
  Product: "Product",
  Invoice: "Invoice",
  Details: "Details",
  Checkout: "Checkout",
  Calendar: "Calendar",
  Analytics: "Analytics",
  Ecommerce: "E-commerce",
  Management: "Management",
  Menu: "Menu",
  Item_disabled: "Item disabled",
  Item_label: "Item label",
  Item_caption: "Item caption",
  Other_cases: "Other cases",
  Item_by_roles: "Item by roles",
  Only_admin_can_see_this_item: "Only admin can see this item",
  TotalElementarySchool: "Total years of elementary school",
  TotalMiddleSchool: "Total years of middle school education",
  TotalHighSchool: "Total years of high school education",
  TotalPreUniversity: "Total years of pre-university education",
  TotalAssociate: "Total academic years of associate degree",
  TotalUndergraduate: "Total years of undergraduate study",
  TotalMaster: "Total years of study for the master's degree",
  TotalDoctoral: "Total years of doctoral studies",
  TotalProfessional: "Total technical and professional academic years",
  Organization: "Organization",
  Degree: "Degree",
  Major: "Major",
  SelectType: "Select Type",
  StartDate: "Start Date",
  EndDate: "End Date",
  City: "City",
  Country: "Country",
  Relation: "Relation",
  CityofResidence: "City of Residence",
  ProvinceofResidence: "Province of Residence",
  ActivityType: "Activity Type",
  ActivityLocation: "Activity Location",
  License: "License",
  MoreInformation: "More Information",
  PassportNumber: "Passport Number",
  IssueDate: "Issue Date",
  ExpiryDate: "Expiry Date",
  DayPerWeek: "Day Per Week",
  HourPerDay: "Hour Per Day",
  CompanyPhone: "Company Phone",
  CEOName: "CEO Name",
  CEOPhoneNumber: "CEO Phone Number",
  YourManagerName: "Manager Name",
  YourManagerTitle: "Manager Title",
  YourManagerPhoneNumber: "Manager Phone Number",
  CompanyPostalCode: "Company Postal Code",
  // ----------------------------

  ActivityLocationHelper: "",
  FullTime: "Full Time",
  PartTime: "Part Time",
  Citizen: "Citizen",
  PermanentResidence: "Permanent Residence",
  TemporaryResidence: "Temporary Residence",
  StatusinCanada: "Status in Canada",
  Spouse: "Spouse",
  Background: "Background",
  Documents: "Documents",
  Questioner: "Questionnaire",
  Personal: "Personal",
  PersonalPhoto: "",
  InformationAboutPersonalPhoto: "Information about personal photo",
  UploadFile: "Upload File",
  PrintTime: "Print Time",
  TranslationDateIfTranslated: "Translation Date (if translated)",
  NationalID: "National ID",
  MilitaryServiceLicense: "Military Service License",
  PhotocopyMarriageCertificate: "Photocopy of Marriage License/Certificate",
  IDCard: "ID Card",
  PhotocopyDivorceDocuments: "Photocopy of Divorce Documents",
  NumberofChildren: "Number of Children",
  Consultants: "Consultants",
  MyAccount: "My Account",
  Management: "Account Management",
  consultant: "Consultant",
  applicant: "Applicant",
  ShareWhatThinkingAbout: "Share what you are thinking about",
  Post: "Post",
  Logout: "Logout",
  Home: "Home",
  Beta: "Beta",
  SignUp: "Sign Up",
  Dashboard: "Dashboard",
  Pages: "Pages",
  Other: "Other",
  AboutUs: "About Us",
  ContactUs: "Contact Us",
  Pricing: "Pricing",
  Login: "Log in",
  Register: "Register",
  ResetPassword: "Reset Password",
  WriteComment: "Write a comment…",
  Authentication: "Authentication",
  SortBy: "Sort By",
  Name: "Name",
  Applicants: "Applicants",
  Immigrationfromhereto: "Immigration from here to",
  Canada: "Canada",
  BetterProbroadimmigrationplatform: "BetterPro is a broad immigration platform for both immigrants and consultants to find one another and stay in touch!",
  GetStarted: "Get Started",
  HowBetterProHelpYou: "How does BetterPro help you?",
  ServicesForConsultants: "Special services for consultants",
  Questionnaire: "Questionnaire",
  QuestionnaireSubTitle: "Information Collector Form",
  CollectInformationAboutClients: "Need to complete immigration forms for clients? Collect any information you want about them from their personal information to education by our questionnaire.",
  CollectingDocuments: "Categorised Documents",
  CollectingDocumentsSubTitle: "Collecting Documents",
  GatherDocumentsfromApplicants:
    "Collect all of the documents at one place but organized for each case! Each immigration case is a different experience, so you’re going to need a categorized manner for it!",
  SafeCommunication: "Safe & Constant Communication",
  ConsultantsApplicantsCommunicate: "From the initial assessment to obtaining a visa! Communicate with your clients at all stages of their immigration process safe & sound.",
  ProfilePage: "Profile Page",
  ProfilePageSubTitle: "for multiple languages",
  HavinguptodateProfiles: "Make a profile page in any language you want and update it! Having an up-to-date profile in multiple languages will help you attract more customers.",
  PlansCustomized: `Customized Plans to meet the needs of your company!`,
  MakeModernOnline: "Choose your plan & make your modern online business Successful.",
  PlusTaxes: " * Plus applicable taxes",
  mo: "/mo",
  POPULAR: "POPULAR",
  Basic: "basic",
  ThirtyDaysTrial: "30 days trial",
  SixtyDaysTrial: "60 days trial",
  NinetyDaysTrial: "90 days trial",
  MultilanguageProfile: "Multilanguage Profile",
  Blogging: "Blogging",
  AccessToLeads: "Access To Leads",
  ComminicateWithClients: "Comminicate with clients",
  FullSupport: "Full Support",
  Starter: "Starter",
  Premium: "Premium",
  ChoosePremium: "Choose Premium",
  ChooseStarter: "Choose Starter",
  ChooseBasic: "Choose Basic",
  GetStartedWith: "Let’s work together",
  BetterProPlatformToday: "on BetterPro Platform today",
  WhereFindUs: "where to find us?",
  FeelFreeContactUs: "Feel free to contact us.",
  WeGladHearFromYou: "We'll be glad to hear from you.",
  ToShareYourComment: "To share your comment about",
  PleaseSignup: "Please Signup",
  IAmConsultant: "Register as an immigration consultant ",
  IAmImmigrate: "Register as an applicant for immigration",
  SelectBestOption: "Select best option",
  AlreadyHaveAccount: "Already have an account?",
  BroadImmigrationPlatformBetterPro: "Broad Immigration Platform with BetterPro",
  GetStartedFree: "Get started absolutely free.",
  NoCreditNeeded: "No credit card needed.",
  DontHaveAccount: "Don’t have an account?",
  EnterDetails: "Enter your details below.",
  WelcomeBack: "Hi, Welcome Back",
  RememberMe: "Remember Me",
  ForgotPassword: "Forgot Password?",
  // =======================

  FieldofStudy: "Field of Study",
  TypeofWork: "Type of Work",
  AnnulledMarriage: "Annulled Marriage",
  CommonLaw: "Common-Law",
  DivorcedSeparated: "Divorced / Separated",
  LegallySeparated: "Legally Separated",
  Married: "Married",
  NeverMarriedSingle: "Never Married / Single",
  Widowed: "Widowed",
  RegisterSaveInformation: "Register to save information and receive consultant messages",
  AssessmentForm: "َAssessment Form",
  UserName: "User Name",
  BlogPosts: "Blog Posts",
  NotProfileLanguage: "Consultant does not have a profile for this language. Please select another language.",
  Services: "Services",
  ContactInfo: "Contact Info (Please let the consultant know how best to contact you)",
  PhoneNumber: "Phone Number",
  CountryCitizenship: "Country of Citizenship",
  CountryofResidence: "Country of Residence",
  NetWorthDes: "Your personal net worth includes all your assets and those of your spouse or common-law partner (if applicable), less any liabilities including mortgages and personal debts.",
  YourPersonalNetWorth: "Personal Net Worth",
  YourEducationTraining: "Education and Training",
  SpousePersonalNetWorth: "Spouse Personal Net Worth",
  SpouseEducationTraining: "Spouse Education and Training",
  TheLatestDegree: "Type of latest program or degree",
  FamilyFriendsCanada: "Family or Friends in Canada",
  FamilyMembersLivingCanada: "Is there a family member or relative living in Canada who is at least 18 years old? Where does he or she live?",
  SpouseFamilyMembersLivingCanada: "Does your spouse have family members or relatives living in Canada who are 18 years old or older? Name them and where they live",
  ResultsLessThanTwoYears: "Do you have recent test results?",
  YourEnglishLevel: "English Level",
  YourFrenchLevel: "French Level",
  SpouseEnglishLevel: "Spouse English Level",
  SpouseFrenchLevel: "Spouse French Level",
  AboutSpouse: "Enter your spouse's information for a detailed review of your situation",
  ExamExpireDate: "Exam Expire Date",
  AccordingPassportInformation: "According to passport information",
  GregorianCalendar: "By the Gregorian calendar",
  NeverSpamEmail: "We'll never spam your email.",
  SchoolType: "like school, university, institute,...",
  NameofBranch: "Name of branch or educational unit",
  Branch: "Branch",
  FieldofStudy: "Field of Study",
  CompanyName: "Company Name",
  PurposeTravel: "Purpose of Travel",
  Duration: "Duration",
  FromDate: "From Date",
  ToDate: "To Date",
  ChildrenFromPreviousMarriage: "Enter any children your spouse has from a previous marriage",
  FormerSpouse: "Former Spouse",
  ConsultBeforeFormerSpouse: "Consult with your consultant before entering your former spouse's information",
  SpouseInformation: "Spouse Information",
  CreatedDate: "Created Date",
  FileName: "File Name",
  FileDescription: "File Description",
  CurrentPlan: "Current Plan",
  Upgrade: "Upgrade",
  Subscription: "Subscription",
  ChatingSystem: "Chating System",
  ChatingSystemDes: "Chat with people who visit your profile here! You & your profile visitors can chat through the platform without them sharing their phone number or personal information.",
  AppointmentSystem: "Appointment System",
  AppointmentSystemDes: "Have your own secretary with us! Make appointments, manage your time and get paid for each consultation you provide!",
  ClientManagement: "Contact / Clients",
  ClientManagementSubTitle: "All Clients in one place",
  ClientManagementDes: "Already have some clients who don’t use this system? No worries! You can add all their information here & also use tools in relation to their cases!",
  InvoicingSystem: "Customized Invoice System",
  AgreementGeneration: "Contract Generator",
  AgreementGenerationSubTitle: " Agreement Generator",
  AgreementGenerationDes: "Choose your desired contract from ones in our platform & sign it with your client!",
  InvoicingSystemDes: "Take care of your invoices & refunds for each client easily! With our customized system you don’t have to worry about anything.",
  HaveChildrenUnder22: "Do you have any children under the age of 22?",
  PersonalInformation: "Personal Information",
  ChildrenUnder12: "Number of children under 12",
  ChildrenUnder1221: "Number of children 13 to 21",
  ChildrenUnderOver22: "Number of children over 22",
  ProvideSpouseCharacteristics: "If Married, please provide Spouse's Characteristics in the fields below",
  SpouseAge: "Spouse's Age",
  SpouseHighestEducation: "Spouse's highest level of education achieved:",
  SpouseCompletedAcademicInCanada: "Has your spouse completed at least 2 academic years of full-time study (in a program at least 2 years long) at a secondary or post-secondary school in Canada?",
  SpouseLanguageEnglish: "Spouse's language proficiency in English",
  SpouseLanguageFrench: "Spouse's language proficiency in French",
  SpouseWorkedOutsideCanada10Years: "Has your Spouse worked outside Canada within the past 10 years?",
  SpouseYearsExperience: "How many years of full-time (minimum 30 hours per week) skilled work experience does your Spouse have?",
  SpouseYearsExperienceNumber: "How many Years?",
  SpouseMonthsExperienceNumber: "How many Months?",
  SpouseWorkedInsideCanada: "Has your Spouse worked inside Canada within the past 10 years?",
  SpouseFieldStudy: "Spouse's field of study",
  SpouseWorkExperience: "Spouse's job title and field of work experience",
  EducationalProfile: "Educational Profile",
  HaveGraduatedHighSchool: "Have you graduated high school?",
  HaveReceivedPostSecondaryEducation: "Have you received any post-secondary education or training?",
  ProgramStartDate: "Program start date",
  GraduationDate: "Graduation date",
  CountryStudy: "Country and city of study",
  EmploymentHistory: "Employment History",
  PersonalNetWorth: "Personal Net worth (CAD$)",
  MyServices: "My Services",
  CreateaService: "Create a service",
  MyBlog: "My Blog",
  CreateaPost: "Create a Post",
  Contacts: "Contacts",
  CreateaContact: "Create a Contact",
  MyProfile: "My Profile",
  GoogleSanctions: "If your country is subject to Google sanctions, you should use a VPN to log in or register",
  WrongPassword: "You entered an incorrect password. Once again, please try",
  FileType: "File Type",
};

export default en;
